import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import SettingProperties from "./setting-properties-text.mdx";
import NamingTip from "./naming-tip.mdx";
import Intro from "./intro.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Intro mdxType="Intro" />
    <pre><code parentName="pre" {...{
        "className": "language-react-native"
      }}>{`posthog.capture('user_signed_up')
`}</code></pre>
    <NamingTip mdxType="NamingTip" />
    <SettingProperties mdxType="SettingProperties" />
    <pre><code parentName="pre" {...{
        "className": "language-react-native"
      }}>{`posthog.capture('user_signed_up', {
    login_type: "email",
    is_free_trial: true
})
`}</code></pre>
    <h3 {...{
      "id": "capturing-screen-views"
    }}>{`Capturing screen views`}</h3>
    <h4 {...{
      "id": "with-react-navigationnative-and-autocapture"
    }}>{`With `}<inlineCode parentName="h4">{`@react-navigation/native`}</inlineCode>{` and autocapture:`}</h4>
    <p>{`When using `}<a parentName="p" {...{
        "href": "https://reactnavigation.org/docs/getting-started/"
      }}>{`@react-navigation/native`}</a>{`, screen tracking is automatically captured if the `}<a parentName="p" {...{
        "href": "/docs/libraries/react-native#autocapture"
      }}><inlineCode parentName="a">{`autocapture`}</inlineCode></a>{` property is used in the `}<inlineCode parentName="p">{`PostHogProvider`}</inlineCode>{`:`}</p>
    <p>{`It is important that the `}<inlineCode parentName="p">{`PostHogProvider`}</inlineCode>{` is configured as a child of the `}<inlineCode parentName="p">{`NavigationContainer`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-react-native"
      }}>{`// App.(js|ts)

import { PostHogProvider } from 'posthog-react-native'
import { NavigationContainer } from '@react-navigation/native'

export function App() {
    return (
        <NavigationContainer>
            <PostHogProvider apiKey="<ph_project_api_key>" autocapture>
                {/* Rest of app */}
            </PostHogProvider>
        </NavigationContainer>
    )
}
`}</code></pre>
    <h4 {...{
      "id": "with-react-native-navigation-and-autocapture"
    }}>{`With `}<inlineCode parentName="h4">{`react-native-navigation`}</inlineCode>{` and autocapture:`}</h4>
    <p>{`First, simplify the wrapping of your screens with a shared PostHogProvider:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-react-native"
      }}>{`import PostHog, { PostHogProvider } from 'posthog-react-native'
import { Navigation } from 'react-native-navigation';

export const posthog = new PostHog('<ph_project_api_key>');

export const SharedPostHogProvider = (props: any) => {
  return (
    <PostHogProvider client={posthog} autocapture={{
      captureLifecycleEvents: false,  // Lifecycle events are handled differently for react-native-navigation
      captureTouches: true,
    }}>
      {props.children}
    </PostHogProvider>
  );
};
`}</code></pre>
    <p>{`Then, every screen needs to be wrapped with this provider if you want to capture touches or use the `}<inlineCode parentName="p">{`usePostHog()`}</inlineCode>{` hook `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-react-native"
      }}>{`export const MyScreen = () => {
  return (
    <SharedPostHogProvider>
      <View>
        ...
      </View>
    </SharedPostHogProvider>
  );
};

Navigation.registerComponent('Screen', () => MyScreen);

Navigation.events().registerAppLaunchedListener(async () => {
  posthog.initReactNativeNavigation({
    navigation: {
      // (Optional) Set the name based on the route. Defaults to the route name.
      routeToName: (name, properties) => name,
      // (Optional) Tracks all passProps as properties. Defaults to undefined
      routeToProperties: (name, properties) => properties,
    },
  });
});
`}</code></pre>
    <h4 {...{
      "id": "manually-capturing-screen-capture-events"
    }}>{`Manually capturing screen capture events`}</h4>
    <p>{`If you prefer not to use autocapture, you can manually capture screen views by calling `}<inlineCode parentName="p">{`posthog.screen()`}</inlineCode>{`. This function requires a `}<inlineCode parentName="p">{`name`}</inlineCode>{`. You may also pass in an optional `}<inlineCode parentName="p">{`properties`}</inlineCode>{` object.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`posthog.screen('dashboard', {
    background: 'blue',
    hero: 'superhog',
})
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      